import { Stack, styled } from "@mui/material"
import { AsideSectionAreas } from "../AsideSection"

export const AsideSectionSummaryLayout = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(2),
  gridArea: AsideSectionAreas.aside,
}))
